import { makeValidated } from '../utils';
import interpolate from '../interpolate';
import schema from '../../schema/merge-layout-property.schema.json';

const mapMergeLayoutProperty = action => ({
  type: 'LAYOUT_MERGE',
  payload: {
    value: action.data.value,
    path: action.data.path,
  },
});

const mergeLayoutProperty = (context, event, meta) => {
  const validated = makeValidated(schema);
  return mapMergeLayoutProperty(
    validated(interpolate(meta.action, event, context))
  );
};

export default mergeLayoutProperty;
